import { Provider } from 'react-redux';
import { WagmiConfig } from 'wagmi';

import wagmiClient from 'config/wagmi';
import Router from './router';
import Notifications from 'components/notifications';

import { WithTranslation, WithMaintenanceMode } from 'hoc';

import { store } from 'store/rootStore';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <Provider store={store}>
      <WithTranslation>
        <WagmiConfig client={wagmiClient}>
          <BrowserRouter>
            <WithMaintenanceMode>
              <div className="App">
                <Router />
                <Notifications />
              </div>
            </WithMaintenanceMode>
          </BrowserRouter>
        </WagmiConfig>
      </WithTranslation>
    </Provider>
  );
}

export default App;
